import React from 'react';
import AtlasV2ComparableSplineChart from 'src/components/AtlasV2Components/AtlasV2graphs/AtlasV2ComparableSplineChart';

// Paid Traffic Chart that is on top of Paid traffic
const AtlasV2PaidTrafficSplineChart = () => {
  return <AtlasV2ComparableSplineChart indexName="traffic" fieldName="adClicks" />;
};

export default AtlasV2PaidTrafficSplineChart;
